import shopifyPlatformHelpers from 'Platforms/shopify/platformHelpers';

function getCookiebotScript() {
  return document.querySelector('script[src*="consent.cookiebot.com/uc.js"]');
}

export default {
  ...shopifyPlatformHelpers,

  getStoragePermissions() {
    const consent = window.Cookiebot?.consent;
    if (consent) {
      return {
        analytics: consent.statistics ?? null,
        functional: consent.preferences ?? null,
      };
    }

    return getCookiebotScript()
      ? { analytics: null, functional: null }
      : shopifyPlatformHelpers.getStoragePermissions();
  },

  initializePlatformStorage(onStoragePermissionsChanged) {
    window.addEventListener('CookiebotOnConsentReady', onStoragePermissionsChanged);

    const script = getCookiebotScript();
    if (!script) {
      return shopifyPlatformHelpers.initializePlatformStorage(onStoragePermissionsChanged);
    }
    if (window.Cookiebot?.consent || document.readyState === 'complete') {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const onLoaded = () => {
        script.removeEventListener('load', onLoaded);
        script.removeEventListener('error', onLoaded);
        window.removeEventListener('load', onLoaded);
        resolve();
      };

      script.addEventListener('load', onLoaded);
      script.addEventListener('error', onLoaded);
      window.addEventListener('load', onLoaded);
    }).then(onStoragePermissionsChanged);
  },
};
